import { render, staticRenderFns } from "./CollapseSearch.vue?vue&type=template&id=c6cb6f3a&"
import script from "./CollapseSearch.vue?vue&type=script&lang=js&"
export * from "./CollapseSearch.vue?vue&type=script&lang=js&"
import style0 from "./CollapseSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports